import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { RendezVous } from '../model/rendez-vous';
import { AssocierRequestAuComite } from '../model/associer-request-au-comite';
import { RendezVousSelectedDTO } from '../model/rendez-vous-selected-dto';

@Injectable({
    providedIn: 'root'
  })
  export class RendezVousService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllRendezVous() 
    {
        return this._restClientService.load<RendezVous[]>('rendez-vous/find-all');
    }
    
    getComiteInterne() 
    {
        return this._restClientService.load<RendezVous[]>('rendez-vous/comite-interne');
    }
    
    getComiteSuperieur() 
    {
        return this._restClientService.load<RendezVous[]>('rendez-vous/comite-superieur');
    }

    getComiteDeclassement() {
        return this._restClientService.load<RendezVous[]>('rendez-vous/comite-declassement');
    }
    
    add(rendezVous: RendezVous) {
        return this._restClientService.save<RendezVous>('rendez-vous/add-rendez-vous', rendezVous);
    }
      
    associer(associerRequestAuComite: AssocierRequestAuComite) {
        return this._restClientService.save<void>('rendez-vous/associer-request-comite', associerRequestAuComite);
    }

    associerDeclassemet(associerRequestAuComite: AssocierRequestAuComite,requestid :string) {
        return this._restClientService.save<void>(
          `rendez-vous/associer-request-comite-declassement?requestid=${requestid}`,
          associerRequestAuComite
        );
    }

    associerrendevousByRequest(requestid: string, rendezVousId: string) {
        return this._restClientService.save<void>(
            `rendez-vous/associer-request-comite-by-request?requestid=${requestid}&rendezVousId=${rendezVousId}`,
            {} 
        );
    }

        
    findSelected(requestid,typecomite) 
    {
        return this._restClientService.load<RendezVousSelectedDTO[]>('rendez-vous/find-selected?requestid='+requestid+"&typecomite="+typecomite);
    }

    findSelectedDeclassement(requestid, typecomite) {
        return this._restClientService.load<RendezVousSelectedDTO[]>(
          "rendez-vous/find-selected-declassement?requestid=" +
            requestid +
            "&typecomite=" +
            typecomite
        );
    }


    getCurrentRendezVousByType(typecomite) 
    {
        return this._restClientService.load<RendezVous[]>('rendez-vous/current-rendez-vous-by-type?typecomite='+typecomite);
    }
    
    getRendezVousById(id) 
    {
        return this._restClientService.load<RendezVous>('rendez-vous/rendez-vous-by-id/'+id);
    }
    

}     

    